import { Component, Input, OnInit } from '@angular/core';

import { isClienteCadastroProspect, isClienteCadastroCliente, isClienteCadastroBaixado, isClienteCadastroOutros } from '../../../cadastro';
import { isClienteSituacaoNovo, isClienteSituacaoPositivo, isClienteSituacaoAtivo, isClienteSituacaoPreInativo, isClienteSituacaoInativo, isClienteSituacaoCongelado, isClienteSituacaoBloqueado, isClienteSituacaoPreBaixado, isClienteSituacaoBaixado, isClienteSituacaoOutros } from '../../../situacao';

@Component({
    selector: 'sgt-cliente-cadastro-situacao-card-chart',
    templateUrl: './cliente-cadastro-situacao-card-chart.component.html',
    styleUrls: ['./cliente-cadastro-situacao-card-chart.component.less']
})
export class ClienteCadastroSituacaoCardChartComponent implements OnInit {
    @Input() cadastro: number;
    @Input() situacao: number = null;
    @Input() nome: string;
    @Input() quantidadeClientes: number;
    @Input() percParticipacao: number;

    cadastroClass: string;
    situacaoClass: string;

    ngOnInit(): void {
        this.cadastroClass = this.getCadastroClass();
        this.situacaoClass = this.getSituacaoClass();
    }

    private getCadastroClass() {
        // Prospect
        if (isClienteCadastroProspect(this.cadastro)) {
            return 'cadastro-prospect';
        }
        // Cliente
        if (isClienteCadastroCliente(this.cadastro)) {
            return 'cadastro-cliente';
        }
        // Baixado
        if (isClienteCadastroBaixado(this.cadastro)) {
            return 'cadastro-baixado';
        }
        // Outros
        if (isClienteCadastroOutros(this.cadastro)) {
            return 'cadastro-outros';
        }
    }

    private getSituacaoClass() {
        // Novo
        if (isClienteSituacaoNovo(this.situacao)) {
            return 'situacao-novo';
        }
        // Positivo
        if (isClienteSituacaoPositivo(this.situacao)) {
            return 'situacao-positivo';
        }
        // Ativo
        if (isClienteSituacaoAtivo(this.situacao)) {
            return 'situacao-ativo';
        }
        // Pré-Inativo
        if (isClienteSituacaoPreInativo(this.situacao)) {
            return 'situacao-preinativo';
        }
        // Inativo
        if (isClienteSituacaoInativo(this.situacao)) {
            return 'situacao-inativo';
        }
        // Congelado
        if (isClienteSituacaoCongelado(this.situacao)) {
            return 'situacao-congelado';
        }
        // Bloqueado
        if (isClienteSituacaoBloqueado(this.situacao)) {
            return 'situacao-bloqueado';
        }
        // Pré-Baixado
        if (isClienteSituacaoPreBaixado(this.situacao)) {
            return 'situacao-prebaixado';
        }
        // Baixado
        if (isClienteSituacaoBaixado(this.situacao)) {
            return 'situacao-baixado';
        }
        // Outros
        if (isClienteSituacaoOutros(this.situacao)) {
            return 'situacao-outros';
        }
    }
}
